import { string, func } from 'prop-types'
import { TextInput, kuiperClassNames } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'

import './styles.scss'

export const buildTime = (value, forcePrependZero = false) => {
  const iterator = [0, 1, 2, 3, 4]

  return iterator
    .map((counter) => {
      const prevCharacter = value[counter - 1]
      if (forcePrependZero) {
        if (counter === 0) {
          return '0'
        }
        if (counter === 1) {
          return prevCharacter
        }
      }

      if (counter === 2) {
        return ':'
      }

      return ' '
    })
    .join('')
}

export const formatMask = (value) => {
  if (value === '') return value

  if (value.match(/^\s\d{1}\D?/) || value.length === 1) {
    return buildTime(value, true)
  }

  return buildTime(value)
}

const TimeInput = ({ onBlur, onChange, value = '' }) => (
  <AnalyticsLayer name="Time Input">
    <div
      className={kuiperClassNames('time-input', {
        withSpacer: value.length === 1,
      })}
    >
      <TextInput
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        placeholder="HH:MM"
        name="timeInput"
      />
      <div className={kuiperClassNames('placeholder-mask')}>
        {formatMask(value)}
      </div>
    </div>
  </AnalyticsLayer>
)

TimeInput.propTypes = {
  onBlur: func,
  onChange: func,
  value: string,
}

export default TimeInput
